import { INTEGRATION_PROCESSING_INACTIVE_CODE } from '@aica/api-types';
import type { ExpectedRefusal } from './base';

/**
 * The refusal of a re-analysis / retry whose record belongs to a Uspacy
 * installation with processing paused or withdrawn (#2709): HTTP 409 with
 * `code: 'INTEGRATION_PROCESSING_INACTIVE'`. The screens say why in the
 * reader's language instead of the generic «the record has already changed».
 */
export const PROCESSING_PAUSED_CODE = INTEGRATION_PROCESSING_INACTIVE_CODE;

/**
 * The same refusal as an expected answer of a request: the screen names the
 * reason — an answer, not a failure (#1751). One list for every client method
 * that can meet it (record re-analysis and retries, admin delivery retry).
 */
export const PROCESSING_PAUSED_REFUSALS: readonly ExpectedRefusal[] = [
  { status: 409, code: PROCESSING_PAUSED_CODE },
];

/** Whether a failed request was refused because the record's source is stopped. */
export function isProcessingPausedError(err: unknown): boolean {
  const failure = err as { status?: unknown; data?: { code?: unknown } | null } | null;
  return failure?.status === 409 && failure.data?.code === PROCESSING_PAUSED_CODE;
}
